import Component from './BadgeDropdown.component';

export default Component;
